import {RcFile} from "antd/es/upload";
import {MAX_FILE_SIZE} from "../../constans/files/fileAcceptTypes";

export const validateFileSize = (file: RcFile): boolean => {
  return file.size <= MAX_FILE_SIZE;
};

export const getFileSizeErrorMessage = (intl: any): string => {
  const maxSizeInMB = MAX_FILE_SIZE / (1024 * 1024);
  return intl.formatMessage(
    {
      id: "common.error.fileTooLarge",
      defaultMessage: "File size must not exceed {maxSize} MB",
    },
    {maxSize: maxSizeInMB}
  );
};

